import { styled, Text, GetProps } from 'tamagui'

export const GradientText = styled(Text, {
  name: 'GradientText',
  fontFamily: '$heading',
  tag: 'span',

  style: {
    display: 'inline',
    backgroundImage: 'linear-gradient(135deg, #FF6300 0%, #FF9D3A 50%, #FFE0AD 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
})

export type GradientTextProps = GetProps<typeof GradientText>
